import { FC } from 'react';
import cls from 'classnames';
import RCTable from 'rc-table';
import { TableProps as RCTableProps } from 'rc-table/lib/Table';
import styles from './index.less';


export interface TableProps extends RCTableProps {
  
}

const Table: FC<TableProps> = ({ className, ...props }) =>
  <RCTable
    {...props}
    className={cls(styles.table, className)}
  />

export { ColumnType } from 'rc-table/lib/interface';
export default Table;
